import { useEffect, useState } from "react";
import analytics from "../analytics/analytics.js";
import { browserStorageManager } from "../utils/browserStorage.js";
import { transformSessionResponse } from "../utils/sessionUtils.js";
import UseRefreshSessionAccess from "./UseRefreshSessionAccess.js";
const UseLoadPreviousPrompts = (args)=>{
    const [statusMsg, setStatusMesg] = useState('');
    const { retrieveUrl, cguid, lastPromptId, limit = 5, loadMoreMessages, setRetrievalLoading, setChatMessages, setLastPromptId, setLoadMoreMessages, isSessionActive } = args;
    UseRefreshSessionAccess();
    useEffect(()=>{
        const abortController = new AbortController();
        setTimeout(()=>{
            abortController.abort();
        }, 30000);
        const fetchMe = async ()=>{
            const pennysid = browserStorageManager.getBrowserStorage()?.getItem('pennysid') ?? '';
            return await fetch(retrieveUrl, {
                method: 'POST',
                signal: abortController.signal,
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    pennysid,
                    cguid,
                    promptId: lastPromptId,
                    limit,
                    isSessionActive
                })
            });
        };
        if (loadMoreMessages && isSessionActive) fetchMe().then(async (result)=>{
            const sessionResult = await result?.json();
            if (sessionResult?.token) browserStorageManager.getBrowserStorage()?.setItem('pennysid', sessionResult.token);
            const sessionData = sessionResult.data;
            if (sessionData?.length) {
                const sessionChatMessage = sessionData.map((item)=>transformSessionResponse(item));
                setLastPromptId(sessionData[0]?.promptId);
                setChatMessages((prev)=>[
                        ...sessionChatMessage,
                        ...prev
                    ]);
                setStatusMesg('Success');
            } else setStatusMesg('No Data');
        }).catch((e)=>{
            setStatusMesg('Failed');
            analytics.log({
                source: 'Chatbot retrieve error',
                message: e
            });
        }).finally(()=>{
            setRetrievalLoading(false);
            setLoadMoreMessages(false);
        });
    }, [
        loadMoreMessages,
        isSessionActive
    ]);
    return {
        statusMsg
    };
};
const useLoadPreviousPrompts = UseLoadPreviousPrompts;
export { useLoadPreviousPrompts as default };
